import { addBackgroundToImagePs, imageHasTransparent, isWhiteMoreThan50Percent } from "@/utils/image";
import { uploadFileList } from '@/utils/aliyunUpload';
import { getLocalImageSize } from "@/utils";
import { localUpload } from "@/components/ImageSelect/service";
import { useArtworkStore } from "@/store/artwork";

interface AutoFillBackgroundResult {
    autoFillBackground: (imgSrc: string, artworkId?: string | number) => Promise<any>;
}

/**
 * 自动填充图片背景的Hook
 * 检测图片是否有透明区域，并自动填充黑色或白色背景
 */
export function useAutoFillBackground(): AutoFillBackgroundResult {
    /**
     * 自动填充图片背景
     * @param imgSrc - 图片源地址
     * @param artworkId - 作品ID，默认使用当前艺术作品ID
     * @returns 处理后的图片数据
     */
    const autoFillBackground = async (imgSrc: string, artworkId?: string | number): Promise<any> => {
        try {
            // 如果未传入artworkId，使用当前艺术作品ID
            const currentArtworkId = artworkId || useArtworkStore().artworkState.id;
            // 若没有有效的作品ID，则无法继续处理
            // if (!currentArtworkId) {
            //     console.warn('自动填充背景失败: 未提供有效的作品ID');
            //     return null;
            // }

            // 检查图片是否有透明区域
            const hasTransparent = await imageHasTransparent(imgSrc);

            if (!hasTransparent) {
                return null; // 如果没有透明区域，不需要处理
            }

            // 检查是否白色区域超过50%
            const whiteCheckRes = await isWhiteMoreThan50Percent(imgSrc);

            // 添加背景色到图片（白色区域多则添加黑色背景，否则添加白色背景）
            const res = await addBackgroundToImagePs(imgSrc, whiteCheckRes ? '#000000' : '#FFFFFF');
            const uploadList = [res.file];

            // 获取图片尺寸
            const imageSizeList = await getLocalImageSize(uploadList);
            // 上传文件到七牛云
            const imageUrlList = await uploadFileList(uploadList);

            // 上传到服务器
            const { data } = await localUpload({
                artworkId: currentArtworkId,
                type: 4,
                image: uploadList.map((_item, index) => {
                    return {
                        width: imageSizeList[index].width,
                        height: imageSizeList[index].height,
                        image: imageUrlList[index],
                        size: uploadList[index].size
                    }
                })
            });

            return data[0]; // 返回处理后的图片数据
        } catch (error) {
            console.error('自动填充背景失败:', error);
            return null;
        }
    };

    return {
        autoFillBackground
    };
} 